{
  "layer_dwg": "Ebene als DWG",
  "layer_kml": "Ebene als KML",
  "drawing_units": "Einheiten zeichnen",
  "coordinate_system": "Koordinatensystem",
  "advanced_rebase_options": "Erweiterte Rebase-Optionen",
  "source_latitude": "Breitengrad der Quelle",
  "source_longitude": "Längengrad der Quelle",
  "target_x": "Ziel X",
  "target_y": "Ziel Y",
  "target_rotation": "Zieldrehung (Grad)",
  "export_dwg": "DWG exportieren",
  "route_convert_line": "In Linie konvertieren",
  "route_convert_confirmation": {
    "title": "Route in Linie umwandeln",
    "message": "Möchten Sie diese Route wirklich in eine Linie umwandeln? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "styles": {
    "lineTypes": {
      "dotted": "Gepunktet",
      "smallDash": "Klein gestrichelt",
      "largeDash": "Groß gestrichelt"
    }
  },
  "no_copy_empty_group": "Kopieren nicht möglich: Die Auswahl enthält keine Ebenen",
  "map_group_status": {
    "title": "Gruppiere Ebenen/Gruppen",
    "explain": "Gruppiere Ebenen und andere Gruppen zusammen",
    "nested_level": "Gruppen können nur 3 Ebenen tief sein",
    "parent": "Artikel können nicht in verschiedenen Gruppen sein",
    "amount": "Wählen Sie mindestens ein Element aus, um die Gruppierung zu aktivieren",
    "type": "Die Auswahl darf keine Kartenobjekte enthalten",
    "loading": "Warte, bis die Karte vollständig geladen ist",
    "permissions": "Für die Gruppierung ist die Berechtigung „Vollzugriff“ für den Plan erforderlich"
  },
  "map_unlink_status": {
    "title": "Trennen Sie die Verknüpfung der Ebenen",
    "explain": "Löst Ebenen und kopiert sie aus ihrem ursprünglichen Plan",
    "amount": "Wählen Sie mindestens eine verknüpfte Ebene aus, um die Verknüpfung von Ebenen aufheben zu können",
    "type": "Die Auswahl darf nur verknüpfte Ebenen enthalten",
    "loading": "Warte, bis die Karte vollständig geladen ist",
    "permissions": "Zum Trennen von Layern ist eine Bearbeitungsberechtigung für den Plan erforderlich"
  },
  "copy_status": {
    "title": "Ebenen/Gruppen kopieren",
    "explain": "Erstellt eine Kopie der ausgewählten Ebenen und Gruppen",
    "amount": "Wählen Sie mindestens eine Ebene aus, um das Kopieren von Ebenen zu ermöglichen",
    "type": "Die Auswahl darf nur Ebenen und Gruppen enthalten",
    "loading": "Warte, bis die Karte vollständig geladen ist",
    "permissions": "Zum Kopieren von Ebenen und Gruppen ist eine Bearbeitungsberechtigung für den Plan erforderlich"
  },
  "map_delete_status": {
    "title": "Ebenen/Gruppen löschen",
    "explain": "Löscht die ausgewählten Ebenen und Gruppen",
    "amount": "Wählen Sie mindestens eine Ebene oder Gruppe aus, um das Löschen zu aktivieren",
    "type": "Die Auswahl darf nur Ebenen und Gruppen enthalten",
    "loading": "Warte, bis die Karte vollständig geladen ist",
    "permissions": "Zum Löschen von Ebenen und Gruppen ist eine Administratorberechtigung für Ebenen erforderlich"
  },
  "mapBackgroundError": {
    "title": "Kartenhintergrund nicht verfügbar",
    "part1": "Wir konnten das nicht laden",
    "part2": "Hintergrund, also haben wir zu einem anderen gewechselt. Bitte versuche",
    "part3": "Später nochmal."
  },
  "qrCode": {
    "copySuccess": "QR-Code in die Zwischenablage kopiert",
    "copyError": {
      "title": "QR-Code konnte nicht kopiert werden",
      "message": "Bitte versuchen Sie es erneut oder verwenden Sie die Download-Option"
    },
    "downloadSuccess": {
      "title": "QR-Code wurde heruntergeladen",
      "message": "Überprüfe deinen Download-Ordner"
    },
    "downloadError": {
      "title": "Der QR-Code konnte nicht heruntergeladen werden",
      "message": "Bitte versuchen Sie es erneut"
    }
  },
  "splitLines": {
    "title": "Linie teilen",
    "selectMapObject": "Wählen Sie eine einzelne Linie zum Teilen",
    "lockedLayer": "Linie kann nicht geteilt werden: Die Ebene ist gesperrt",
    "linesOnly": "Nur Linienobjekte können geteilt werden",
    "fixedShapes": "Linien mit fester Form können nicht geteilt werden",
    "drawing": "Linie kann beim Zeichnen nicht geteilt werden",
    "action": "Klicken Sie, um die Linie zu teilen",
    "confirmMessage": "Sind Sie sicher, dass Sie diese Linie teilen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "tooltipStart": "Von Anfang an",
    "tooltipEnd": "Bis zum Ende"
  }
}